import React, { useState, Fragment } from "react";
import { withRouter } from "react-router-dom";
import { Icon, Input, Button, Table,Popover, Tooltip, Popconfirm, Modal} from "antd";
import { Link } from "react-router-dom";
import axios from "axios";
import ayudaClaveFUAR from '../../../img/ayudaCambioClave.jpg';
import icono_admin from '../../../img/Administrador.svg';
import icono_acuses from '../../../img/Reenviar-acuses.svg';
import icono_enviar_correo from '../../../img/Correo.svg';
import icono_modificar from '../../../img/Editar.svg';
import icono_visor from '../../../img/Consultar.svg';
import icono_compulsa from '../../../img/Descargar-compulsa.svg';
import icono_descarga_bitacora_correos from '../../../img/Icono_descarga_correos.svg'
import icono_solicitud from '../../../img/Solicitud.svg';
import { etiqueta_bandeja_informacion_sin_documentos, REGEX_FORMATO_SOLO_DIGITOS, etiqueta_mensaje_enviado, etiqueta_mensaje_no_enviado, etiqueta_mensaje_vacio_aspirante, etiqueta_bandeja_compulsa_en_ejecucion, rolesDescargaCompulsa, TIPO_ARCHIVO_PDF, TIPO_ARCHIVO_EXCEL } from '../../../ApplicationResources';
import { cargarAspirante, descargarAcuseCompulsa, obtenerIpCliente } from "../../../utils/funciones";
import { implantarAspirante } from "../../../redux/user/user-actions";
import { emitirOperacion } from "../../../redux/actions/accionesOperacion";
import { connect } from "react-redux";
import { ModalCorreo } from "./ModalCorreo";
import { obtenerNombreBandeja } from "../../../utils/funciones";
import { createStructuredSelector } from "reselect";
import { selectProceso } from "../../../redux/menu/menu-selectors";
import iconoDeclina from '../../../img/icons/Icono_declinacion.png';
import { ReactSVG } from "react-svg";
import { selectCurrentUser } from "../../../redux/user/user-selectors";
import * as etiquetas from '../../../ApplicationResources';
import errorImgModal from '../../../img/error_icon.svg';
import infoImgModal from '../../../img/infow_icon.png';
import { general_error_descarga_archivo,bandeja_descarga_pdf_compulsa_en_proceso } from '../../../ApplicationResources';

const { Column } = Table;

/* Este componente es la tabla que muestra el listado  de busqueda en la  bandeja de entrada*/
const rolesAdmin =  [ "SCE.ADMIN.OC", "SCE.UNICOM.OC", "SCE.CAPTURA.OC", "SCE.CAPTURA.JD", "SCE.CAPTURA_VCEYEC.JD" ];

function TablaBandejaBusqueda({
  actualizarCargando,
  datos,
  banderaVisualizar,
  keyTabPane,
  tipoUsuario,
  implantarAspirante,
  history,
  emitirOperacion,
  rol,
  proceso,
  rolOPLE,
  datosUsuario
}) {
  //State que se usa
  const [setState] = useState({ searchText: "" });
  /*Metodos para el manejo de tablas */

  const[modalErrorMsj, setShowModalErrorMsj] = useState({
    msjError: "", 
    abrirModalError: false
  })

  const[modalTemplate, setModalTemplate] = useState({
    msj: '', 
    mostrar: false,
    tipo: 'info',
    img: undefined
  })

  const[fileLists, setFileLists] = useState([]);

  const handleSearch = (selectedKeys, confirm) => {
    confirm();
    setState({ searchText: selectedKeys[0] });
  };

  var handleReset = clearFilters => {
    clearFilters();
    setState({ searchText: "" });
  };

  const functionFilterIcon = filtered => (
    <Icon type="search" style={{ color: filtered ? "#1890ff" : undefined }} />
  );

  const functionFilterDropdown = ({
    setSelectedKeys,
    selectedKeys,
    confirm,
    clearFilters
  }) => {
    return (
      <div style={{ padding: 8 }}>
        <Input
          placeholder={`Buscar `}
          value={selectedKeys[0]}
          onChange={e =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm)}
          style={{ width: 188, marginBottom: 8, display: "block" }}
        />
        <Button
          type="primary"
          onClick={() => handleSearch(selectedKeys, confirm)}
          icon="search"
          size="small"
          style={{ width: 90, marginRight: 8 }}
        >
          Buscar
        </Button>
        <Button
          onClick={() => handleReset(clearFilters)}
          size="small"
          style={{ width: 90 }}
        >
          Limpiar
        </Button>
      </div>
      );
    };

  const functionFilterDropdownA = ({
    setSelectedKeys,
    selectedKeys,
    confirm,
    clearFilters
    }) => {
    return (
      <Popover overlayClassName='pop_tooltip'
          disabled={false}
          content={<img src={ayudaClaveFUAR} width='500px'/>}>
            <marginRight>
            <Icon type="question-circle" style={{ color: 'rgba(0,0,0,.45)' }} />
            </marginRight>
        </Popover>
    );
  };

  const functionOnFilterDropdownVisibleChange = visible => {};

  const functionRenderValidado = (text, record) =>  {
    let icono = record.estatusRegistro === 5 ? true: false;
    let asterisco = record.claveElector.length < 18 ? true: false;
    if(icono || asterisco){
      return (
        <span>
          {asterisco ? <b style={{color:'#C192F3'}}>*&nbsp;</b> : null}
          {icono ?
          <Popover placement="bottomRight"
              disabled={false}
              content={"El aspirante decidió declinar su solicitud."}>
                <marginRight>
            <img src={iconoDeclina} /> 
          </marginRight>
          </Popover>: null}{" "+text+""} 
        </span>
      );
    }else{
      return (
        text + ""
      );
    }};

  const functionRender = text => {

    return (
      text+""
    );
    };
  const [modalCorreo, setShowModalCorreo] = useState({
        visible: false,
        confirmDialog: false,
  });
  const [datosModalCorreo, setDatosModalCorreo] = useState({
      correo: "",
      asunto: "",
      mensaje: "",
      caracteresRestantes: 0,
      idProcesoElectoral: undefined,
      idDetalleProceso: undefined,
      idParticipacion: undefined,
      idAspirante: undefined
  });
  const showModalCorreo = async (record) => {
        setDatosModalCorreo({
            correo: record.correoElectronico,
            asunto: obtenerNombreBandeja(record.keyBandeja),
            mensaje: "",
            caracteresRestantes: 3000,
            nombre: record.nombre,
            descripcionProceso: proceso.descripcionDetalleLarga,
            idProcesoElectoral: record.idProceso,
            idDetalleProceso: record.idDetalle,
            idParticipacion: record.idParticipacion,
            idAspirante: record.idAspirante
        });
        setShowModalCorreo({ visible: true, confirmDialog: true });
        setFileLists([]);
    };
    const hideModalCorreo = async (record) => {
        setShowModalCorreo({ visible: false, confirmDialog: false });
    };
    const handleOnChangeModalCorreo = (event) => {
        setDatosModalCorreo({
            correo: datosModalCorreo.correo,
            asunto: datosModalCorreo.asunto,
            mensaje: event.target.value,
            caracteresRestantes: 3000 - event.target.value.length,
            nombre: datosModalCorreo.nombre,
            descripcionProceso: datosModalCorreo.descripcionProceso,
            idProcesoElectoral: datosModalCorreo.idProcesoElectoral,
            idDetalleProceso: datosModalCorreo.idDetalleProceso,
            idParticipacion: datosModalCorreo.idParticipacion,
            idAspirante: datosModalCorreo.idAspirante
        });
    }
    const [modalConfirmaCorreo, setShowModalConfirmaCorreo] = useState({
        visible: false,
        confirmDialog: false,
        mensajeConfirmacion: ""
    });
    const hideModalConfirmaCorreo = async (record) => {
        setShowModalConfirmaCorreo({ visible: false, confirmDialog: false });
        setShowModalCorreo({ visible: false, confirmDialog: false });
    };
    const enviarCorreo = async () => {
        try {
          
          if (datosModalCorreo.mensaje === "") {
            setShowModalConfirmaCorreo({ visible: true, confirmDialog: true, mensajeConfirmacion: etiqueta_mensaje_vacio_aspirante });
            return;
          }

          const ipCliente = await obtenerIpCliente()
          let docAdjunto = fileLists[0];
          const formData = new FormData();

          var postData = {
              idProcesoElectoral: datosModalCorreo.idProcesoElectoral,
              idDetalleProceso: datosModalCorreo.idDetalleProceso,
              idParticipacion: datosModalCorreo.idParticipacion,
              idAspirante: datosModalCorreo.idAspirante,
              correo: datosModalCorreo.correo,
              asunto: datosModalCorreo.asunto,
              mensaje:datosModalCorreo.mensaje,
              nombre: datosModalCorreo.nombre,
              descripcionProceso: datosModalCorreo.descripcionProceso,
              usuario: datosUsuario.username,
              ipUsuario: ipCliente,
              uid: '',
              type: '',
              name: ''
          };

          if(docAdjunto !== undefined && fileLists.length > 0){
            postData.uid = docAdjunto.uid;
            postData.type = docAdjunto.type;
            postData.name = docAdjunto.name;
          }
    
          formData.append('files', docAdjunto);
          formData.append('dtoRequest',new Blob([JSON.stringify(postData)],{type:"application/json"}));
          const jwt = localStorage.getItem("jwt-token");

          actualizarCargando({cargando:true});

          const resultado = await axios.post(
              process.env.REACT_APP_API_URL +
              "/ws_reclutaseycae_central/ws/enviarNotificacionPersonalizada",
              formData,
              { headers: { 
                'Content-Type': 'multipart/form-data',
                Authorization: jwt 
              } }
          );
          if (resultado.data.status === 'Éxito') {
              setShowModalConfirmaCorreo({ visible: true, confirmDialog: true, mensajeConfirmacion: etiqueta_mensaje_enviado });
          } else {
              setShowModalConfirmaCorreo({ visible: true, confirmDialog: true, mensajeConfirmacion: etiqueta_mensaje_no_enviado });
          }

          actualizarCargando({cargando:false})
        } catch(err) {
          console.log(err)
          actualizarCargando({cargando:false})
        }
    };  

  const etiquetasEnviarCorreo = (text, record) => (
    <Tooltip title={"Enviar Correo"} placement="top">
      <span>
      <Link disabled={rolOPLE} to="#"
        style={{'visibility':record.correoElectronico === null || record.correoElectronico === undefined ? 'hidden' : 'visible'}}
        className="btn btn-success mr-2"
        onClick={() => showModalCorreo(record)}
      >
        <ReactSVG src={icono_enviar_correo} width="25px" style={rolOPLE ? {'filter':'grayscale(100%)'} : {}} />
      </Link>
    </span>

    </Tooltip>
  );

  const etiquetasDescargarBitacoraCorreo = (text, record) => (
    <div style={{'display':'flex', 'justify-content': 'center'}}>
      <Tooltip title={"Descargar bitácora de correos enviados"} placement="top">
        <span>
          <Link disabled={rolOPLE || record.totalCorreos === 0} to="#"
            className="btn btn-success mr-2"
            onClick={() => descargarBitacoraCorreo(record)}
          >
            <ReactSVG src={icono_descarga_bitacora_correos} width="25px" style={rolOPLE || record.totalCorreos === 0 ? {'filter':'grayscale(100%)'} : {}} />
          </Link>
        </span>
      </Tooltip>
      {
        record.totalCorreos === 0 ?
        <Popover placement="bottomRight"
          disabled={false}
          content={etiquetas.etiqueta_bandeja_sin_correos_enviados}>
            <marginRight>
              <Icon type="info-circle" theme="filled" style={{ color: '#bfbfbf' }} />
            </marginRight>
        </Popover> : ""
      }
    </div>
  )

  const descargarBitacoraCorreo = async (record) => {
    try {
      actualizarCargando({cargando:true})

      const json = {
        idProcesoElectoral : record.idProceso,
        idDetalleProceso: record.idDetalle,
        idParticipacion : record.idParticipacion,
        idAspirante : record.idAspirante,
        nombreProceso : proceso.descripcionDetalleLarga
      }

      // Se realiza la descarga del acuse de compulsa
      await descargarAcuseCompulsa(json, `bitacora_correos_${record.folio}.xlsx`, 'generarExcelBitacoraCorreos', TIPO_ARCHIVO_EXCEL)

      actualizarCargando({cargando:false})
    } catch(err) {
      actualizarCargando({cargando:false})
      console.log(err)
    }
  }

  const etiquetasExpediente = (text, record) => (
    <Tooltip title={"Visor"}
              placement="top">
      <span>
      <Link disabled={rolOPLE} to="#"
        className="btn btn-success mr-2"
        onClick={() =>
          cargarAspirante(record.idProceso, record.idDetalle, record.claveElector, record.folioAcceso).then(datosAspirante => {
            emitirOperacion({
              accion: "captura"
            });
            implantarAspirante(datosAspirante);
            history.push("/visor");
          })
        }
      >
        <ReactSVG src={icono_visor} width="25px" style={rolOPLE ? {'filter':'grayscale(100%)'} : {}} />
      </Link>
    </span>

    </Tooltip>
  );

  const etiquetasSolicitud = (text, record) => (

    <Tooltip title={"Descargar solicitud"}
              placement="bottom">
      <Popconfirm
          title={<p><b>Responsiva de Acceso a Información</b><br/>
                Reconozco que la información sensible, reservada o confidencial<br/>
                 a la que tendré acceso, no podré utilizarla, difundirla,<br/>
                 reproducirla, publicarla, cederla y/o usarla con fines<br/>
                 lucrativos, personales o comerciales o en beneficio de terceros.<br/>
                  Artículos 3, 110 y 113 de la Ley Federal de Transparencia y<br/>
                 Acceso a la Información Pública 14 y 15 del Reglamento del<br/>
                 Instituto Nacional Electoral en materia de Transparencia y<br/>
                 Acceso a la Información Pública.
               </p>}
          onConfirm={() =>
            cargarAspirante(record.idProceso, record.idDetalle, record.claveElector, record.folioAcceso).then(datosAspirante => {
              emitirOperacion({
                accion: "captura"
              });
              implantarAspirante(datosAspirante);

              const jwt = localStorage.getItem("jwt-token");
              const headers = {
                  'Accept': 'application/json'
                  ,'Content-Type': 'application/json'
              };
      
              if(jwt){
                  headers['Authorization'] = jwt;
              }

              axios.post(process.env.REACT_APP_API_URL + '/ws_reclutaseycae_central/ws/descargarSolicitud'
                
                  ,{
                    idProcesoElectoral: datosAspirante.idProcesoElectoral,
                    idDetalleProceso: datosAspirante.idDetalleProceso,
                    idParticipacion: datosAspirante.idParticipacion,
                    idAspirante: datosAspirante.idAspirante,
                    idConvocatoria : datosAspirante.idConvocatoria,
                    folio : datosAspirante.folio,
                    claveElector: datosAspirante.claveElectorFuar,
                    usuario: null,
                    ipUsuario: null,
                    sede: datosAspirante.sede,
                  },{
                      headers,
                      responseType: 'blob',
                      transformResponse: [ data => {
                      let blob = new window.Blob([data], {type: "application/pdf"});
                      var link = document.createElement('a');
                      link.href = window.URL.createObjectURL(blob);
                      link.setAttribute('download', `${datosAspirante.claveElectorFuar}.pdf`);
                      document.body.appendChild(link);
                      link.click();
                      document.body.removeChild(link);
                  }]
                }
              ).then(res => {
                console.log("respuesta...",res);
              })
            })
          }
          onCancel={()=>console.log("no acepto la descarga")}
          okText="Aceptar"
          cancelText="Declinar"
        >
      <span>
      <img src={icono_solicitud} width="25px" />
      </span>
    </Popconfirm>
    </Tooltip>
  );

  const etiquetaReenvioAcuses =(text, record) =>(
    <Tooltip title={"Reenviar Acuses"} placement="top">
      <span>
        <Link disabled={rolOPLE} to="#"
          className="btn btn-success mr-2"
          onClick={() =>
            cargarAspirante(record.idProceso, record.idDetalle, record.claveElector, record.folioAcceso).then(datosAspirante => {
              emitirOperacion({
                accion: keyTabPane === "1" ? "captura" : "consulta"
              });
              implantarAspirante(datosAspirante);

              history.push("/reenvioAcuses");
            })
          }>
            <ReactSVG src={icono_acuses} width="25px" style={rolOPLE ? {'filter':'grayscale(100%)'} : {}} />
        </Link>
      </span>
    </Tooltip>
  );

  const etiquetaDescargaCompulsa = (text, record) => {
    const idCorte = proceso ? proceso.corte : 0;
    
    var esClaveElectorFuar = REGEX_FORMATO_SOLO_DIGITOS.test(record.claveElector);
    return (
    !esClaveElectorFuar ? 
    <div>
      <Tooltip title={"Compulsa"} placement="top">
        <span>
          <Link  to="#" className="btn btn-success mr-2" disabled={esClaveElectorFuar || rolOPLE}
                onClick={ async () =>
                  {
                    let descargarArchivo;
                    try {
                      actualizarCargando({cargando:true})

                      await cargarAspirante(record.idProceso, record.idDetalle, record.claveElector, record.folioAcceso).then(async (datosAspirante) => {
                        implantarAspirante(datosAspirante);

                        const json = {
                          idProcesoElectoral : datosAspirante.idProcesoElectoral,
                          idDetalleProceso : datosAspirante.idDetalleProceso,
                          idParticipacion : datosAspirante.idParticipacion,
                          idAspirante: datosAspirante.idAspirante,
                          idConvocatoria : datosAspirante.idConvocatoria,
                          folio : datosAspirante.folio,
                          claveElector: datosAspirante.claveElectorFuar,
                          idCorte : idCorte,
                          nombreProceso : proceso.descripcionDetalleLarga
                        }
                        // Se realiza la llamada a la función para descargar el acuse de compulsa
                        descargarArchivo = await descargarAcuseCompulsa(json, `Compulsa_${datosAspirante.claveElectorFuar}.pdf`, 'descargarAcuse', TIPO_ARCHIVO_PDF);
                      })
                    } catch(err) {
                      console.log("Error al descargar la compulsa", err)
                      setModalTemplate({
                        msj: general_error_descarga_archivo, 
                        mostrar: true,
                        tipo: 'error',
                        img: errorImgModal
                      });
                    } finally {
                      actualizarCargando({cargando:false})
                      
                      if(!descargarArchivo){
                        setModalTemplate({
                          msj: bandeja_descarga_pdf_compulsa_en_proceso, 
                          mostrar: true,
                          tipo: 'info',
                          img: infoImgModal
                        });
                      }
                    }
                }
                }
          > <ReactSVG src={icono_compulsa} width="25px" style={esClaveElectorFuar || rolOPLE ? {'filter':'grayscale(100%)'} : {}} />
          </Link>
        </span>
      </Tooltip>
    </div>:
    <div style={{'display':'flex', 'justify-content': 'center'}}>
      <Tooltip title={"Compulsa"} placement="top">
        <Link disabled={esClaveElectorFuar || rolOPLE} to="#" className="btn btn-success mr-2"> 
          <ReactSVG src={icono_compulsa} width="25px" style={esClaveElectorFuar || rolOPLE ? {'filter':'grayscale(100%)'} : {}} />
        </Link>
      </Tooltip>

      {
        esClaveElectorFuar ?
        <Popover placement="bottomRight"
          disabled={false}
          content={etiquetas.etiqueta_bandeja_sin_compulsa_por_siap}>
            <marginRight>
              <Icon type="info-circle" theme="filled" style={{ color: '#bfbfbf' }} />
            </marginRight>
        </Popover> : ""
      }
    </div>
    )};

    const etiquetaAdmin =(text, record) =>(
      <div style={{'display':'flex', 'justify-content': 'center'}}>
        <Tooltip title={"Administrador"} placement="top">
          <span>
            <Link disabled={record.conCompulsa === -1 || rolOPLE} to="#"
              className="btn btn-success mr-2"
              onClick={async () =>
                {
                  try {
                    actualizarCargando({cargando:true})

                    if(record.conCompulsa !== -1) {
                      await cargarAspirante(record.idProceso, record.idDetalle, record.claveElector, record.folioAcceso).then(datosAspirante => {
                        implantarAspirante(datosAspirante);
                        history.push("/administrarRegistro");
                      })
                    }
                  } catch(err) {
                    console.log("Ocurrió un error al carga el aspirante", err)
                  } finally {
                    actualizarCargando({cargando:false})
                  }
                }
              }
            >
              <ReactSVG src={icono_admin} style={record.conCompulsa === -1 || rolOPLE ? {'filter':'grayscale(100%)'} : {}} width="25px" />
            </Link>
          </span>
        </Tooltip>

        {
          record.conCompulsa === -1 ?
          <Popover placement="bottomRight"
            disabled={false}
            content={etiquetas.etiqueta_bandeja_compulsa_en_ejecucion}>
              <marginRight>
                <Icon type="info-circle" theme="filled" style={{ color: '#bfbfbf' }} />
              </marginRight>
          </Popover> : ""
        }
      </div>
    );

  const OC = 1;
  const JL = 2;

  const funcValida = (text, record) => {
    if(text.idDomAspirante > 0){
      //if(text.idDomAspirante == 1)
      //{
        return('class-otro')
      //}else{return('')}
    }else{return('')}
    
  }

  const funcFileValidation = (archive) => {

    let msjError = '';
    let nombreLargo = archive.name.length > 100;
  
    const permitido = archive.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' || 
                      archive.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' || 
                      archive.type === 'application/pdf';
  
    if (!permitido) {
      msjError = 'El archivo ' + archive.name + ' es de formato no permitido. ' + etiquetas.gral_archivos_permitidos_envia_correo;
      handleOnChangeModalErrorMsj(msjError, true);
      return false;
    }
    
    //Tamanio del archivo no puede superar los 5 MB
    let tamanioPermitido = archive.size / 1024 / 1024 < 5; //5 MB
    let archivoVacio = archive.size === 0;
    if (!tamanioPermitido) {
        msjError = 'El archivo ' + archive.name + etiquetas.gral_peso_archivo_envia_correo;
        handleOnChangeModalErrorMsj(msjError, true);
        return false;
    }
  
    if(archivoVacio){
      msjError = 'El archivo ' + archive.name + ' está vacío';
      handleOnChangeModalErrorMsj(msjError, true);
      return false;
    }
  
    if(nombreLargo){
      msjError = 'El nombre del archivo ' + archive.name + ' es más largo de lo permitido';
      handleOnChangeModalErrorMsj(msjError, true);
      return false;
    }
  
    let archNombrePermitido = validaNombreArchivo(archive.name);
    if(!archNombrePermitido){
      msjError = 'El nombre de archivo '+ archive.name + ' es inválido. '+ etiquetas.gral_error_nombre_archivo;
      handleOnChangeModalErrorMsj(msjError, true);
      return false;
    }
  
    return permitido && tamanioPermitido && archNombrePermitido && !archivoVacio && !nombreLargo
  }
  
  const cerrarErrorModal = () => {
    setShowModalErrorMsj({
      msjError:'',
      abrirModalError:false
    });
  }
  
  const validaNombreArchivo = (e) =>{
    var patron = /^[0-9a-zA-Z_-\s]+.[pdf/PDF/docx/DOCX/xlsx/XLSX]+$/;
    if(e.match(patron)){
        return true;
    }else{
        return false;
    }
  }
  
  const funcChangeList = (func, datosArchivo) => {
    console.log("Entre revisar los cambios en la lista de archivos");
    //Ejecuto el beforeUpload de FileUpload, me permite verificar si el archivo ya fue previamente agregado
    //Returna un array
    const nuevosArchivos = func(fileLists);
    //Validamos 
    if(nuevosArchivos.length>0){
      let repetido = fileLists.length > 0 && fileLists.some(valor=>{return valor.name === nuevosArchivos[0].name});
      if(repetido){
        datosArchivo.archivo = nuevosArchivos && nuevosArchivos[0] !== undefined ? nuevosArchivos[0] : undefined;
        let msjError = 'El archivo ' + nuevosArchivos[0].name + ' se encuentra previamente especificado';
        handleOnChangeModalErrorMsj(msjError, true);
        return fileLists;
      }
      setFileLists([nuevosArchivos[0]]);
  
    }else{
      setFileLists([]);
    }
  
  }
  
  const handleOnChangeModalErrorMsj = (msjError, abrirModal) => {
    setShowModalErrorMsj({
      msjError: msjError,
      abrirModalError: abrirModal
    });
  }


  /*   Pintar la tabla     */
  return (
    <Fragment>
       {banderaVisualizar === false ? (
          <Table
            dataSource={datos}
            title={() => "Resultados de búsqueda"}
            scroll={{x:'max-content'}} rowClassName={funcValida}
          >
            {tipoUsuario === OC?
              <Column
              title="Estado" dataIndex="estado"  key={`estado{keyTabPane}`}
/*               filterDropdown={functionFilterDropdown}
              filterIcon={functionFilterIcon} */
              OnFilterDropdownVisibleChange={
                functionOnFilterDropdownVisibleChange
              }
              render={functionRender}
              onFilter={(value, record) => {
                return record["estado"]
                  .toString()
                  .toLowerCase()
                  .includes(value.toLowerCase());
              }}
            />:<span></span>
          }

          {tipoUsuario === OC || tipoUsuario === JL?
            <Column
            title="Distrito" dataIndex="distrito"  key={`distrito{keyTabPane}`}
/*             filterDropdown={functionFilterDropdown}
            filterIcon={functionFilterIcon} */
            OnFilterDropdownVisibleChange={
              functionOnFilterDropdownVisibleChange
            }
            render={functionRender}
            onFilter={(value, record) => {
              return record["distrito"]
                .toString()
                .toLowerCase()
                .includes(value.toLowerCase());
            }}
          />
            :<span></span>}
            <Column title="Folio" dataIndex="folio" key="folio"
              filterDropdown={functionFilterDropdown}
              filterIcon={functionFilterIcon}
              OnFilterDropdownVisibleChange={
                functionOnFilterDropdownVisibleChange
              }
              render={functionRender}
              onFilter={(value, record) => {
                return record["folio"]
                  .toString()
                  .toLowerCase()
                  .includes(value.toLowerCase());
              }}
            />
            <Column title="Nombre" dataIndex="nombre" key="nombre"
            filterDropdown={functionFilterDropdown}
            filterIcon={functionFilterIcon}
            OnFilterDropdownVisibleChange={
              functionOnFilterDropdownVisibleChange
            }
            render={functionRenderValidado}
            onFilter={(value, record) => {
              return record["nombre"]
                .toString()
                .toLowerCase()
                .includes(value.toLowerCase());
            }} />
            <Column
              title="Clave de elector o SIAP"
              dataIndex="claveElector"
              key="claveElector"
              filterDropdown={functionFilterDropdown}
              filterIcon={functionFilterIcon}
              OnFilterDropdownVisibleChange={
                functionOnFilterDropdownVisibleChange
              }
              render={functionRender}
              onFilter={(value, record) => {
                return record["claveElector"]
                  .toString()
                  .toLowerCase()
                  .includes(value.toLowerCase());
              }}
            />
            <Column
              title="Sección"
              dataIndex="seccion"
              key="seccion"
              filterDropdown={functionFilterDropdown}
              filterIcon={functionFilterIcon}
              OnFilterDropdownVisibleChange={
                functionOnFilterDropdownVisibleChange
              }
              render={functionRender}
              onFilter={(value, record) => {
                return record["claveElector"]
                  .toString()
                  .toLowerCase()
                  .includes(value.toLowerCase());
              }}
            />            
            <Column
              title="Convocatoria"
              dataIndex="numeroConvocatoria"
              key="numeroConvocatoria"
              filterDropdown={functionFilterDropdown}
              filterIcon={functionFilterIcon}
              OnFilterDropdownVisibleChange={
                functionOnFilterDropdownVisibleChange
              }
              render={functionRender}
              onFilter={(value, record) => {
                return record["numeroConvocatoria"]
                  .toString()
                  .toLowerCase()
                  .includes(value.toLowerCase());
              }}
            />
            <Column align={'right'} title="" key="exp" render={etiquetasEnviarCorreo} />
            
            <Column align={'right'} title="" key="exp" render={etiquetasDescargarBitacoraCorreo} />

            <Column
              align={'right'}
              title={functionFilterDropdownA}
              key="action"
              render={(text, record) => (
                <div style={{'display':'flex', 'justify-content': 'center'}}>
                  <Tooltip title={"Modificar"}
                            placement="top">
                  <span>
                    <Link disabled={record.conCompulsa === -1 || rolOPLE} to={record.conCompulsa !== -1 ? `/bandeja/modifica/${record.idProceso}&${record.idDetalle}&${record.idEstado}&${record.idDistrito}&${record.folioAcceso}&${record.claveElector}` : '#'}
                          className="btn btn-success mr-2">
                      <ReactSVG src={icono_modificar} style={record.conCompulsa === -1 || rolOPLE ? {'filter':'grayscale(100%)'} : {}} width="25px" />
                    </Link>
                  </span>
                  </Tooltip>

                  {
                    record.conCompulsa === -1 ?
                    <Popover placement="bottomRight"
                      disabled={false}
                      content={etiquetas.etiqueta_bandeja_compulsa_en_ejecucion}>
                        <marginRight>
                          <Icon type="info-circle" theme="filled" style={{ color: '#bfbfbf' }} />
                        </marginRight>
                    </Popover> : ""
                  }
                </div>
              )}
            />
            <Column align={'right'} title="" key="exp" render={etiquetasExpediente} />
            {
              rol.rolUsuario === "SCE.CAPTURA_VCEYEC.JD" ?
              <Column align={'right'} title="" key="exp" render={etiquetasSolicitud} />
              : ""
            }
            <Column align={'right'} title="" key="exp" render={etiquetaReenvioAcuses}/>
            {rolesDescargaCompulsa.includes(rol.rolUsuario) ?
              <Column align={'right'} title="" key="exp" render={etiquetaDescargaCompulsa} />
            : null}
            {rolesAdmin.includes(rol.rolUsuario) ?
              <Column align={'right'} title="" key="exp" render={etiquetaAdmin} />
            : null}
          </Table>
        ) : (
          <span></span>
        )}

         <ModalCorreo
              visible={modalCorreo.visible}
              confirmLoading={modalCorreo.confirmDialog}
              enviarCorreo={enviarCorreo}
              hideModalCorreo={hideModalCorreo}
              correo={datosModalCorreo.correo}
              asunto={datosModalCorreo.asunto}
              mensaje={datosModalCorreo.mensaje}
              caracteresRestantes={datosModalCorreo.caracteresRestantes}
              handleOnChangeModalCorreo={handleOnChangeModalCorreo}
              visibleConfirma={modalConfirmaCorreo.visible}
              confirmDialogConfirma={modalConfirmaCorreo.confirmDialog}
              hideModalConfirmaCorreo={hideModalConfirmaCorreo}
              mensajeConfirmacion={modalConfirmaCorreo.mensajeConfirmacion}
              validacion={funcFileValidation}
              fileLists={fileLists}
              cambiosList={funcChangeList}
          />
          <Modal className="modalError"
                 title={<img  src={errorImgModal} id="img-error-modal"/>}
                 centered
                 onCancel={cerrarErrorModal}
                 visible={modalErrorMsj.abrirModalError}
                 footer={false}
                 width={400}>
                    {modalErrorMsj.msjError}
          </Modal>
          <Modal className="modalInformativo"
                 title={<img  src={modalTemplate.img} id="img-error-modal"/>}
                 centered
                 onCancel={ ()=> setModalTemplate({mostrar:false})}
                 visible={modalTemplate.mostrar}
                 footer={false}
                 width={400}>
                    {modalTemplate.msj}
          </Modal>
    </Fragment>
  );
}

const mapStateToProps = createStructuredSelector({
  proceso: selectProceso,
  datosUsuario: selectCurrentUser
});

export default withRouter(
  connect(
    mapStateToProps,
    { implantarAspirante,emitirOperacion}
  )(TablaBandejaBusqueda)
);

var css = ' .class-otro{  color: var(--rosa-ine) !important;}',
    head = document.head || document.getElementsByTagName('head')[0],
    style = document.createElement('style');

head.appendChild(style);

style.type = 'text/css';
if (style.styleSheet){
  // This is required for IE8 and below.
  style.styleSheet.cssText = css;
} else {
  style.appendChild(document.createTextNode(css));
}